import React from 'react'

function Project2(props) {
  const { projectDetail } = props;

  return (
    <div className='backgourd-product-detail-2'>
      <div className="project-details project-details-15">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="project-details-content d-flex flex-column align-content-center justify-content-center">
                <h3 className='text-white d-flex justify-content-center mt-0'>{ projectDetail.details }</h3>
                <p className='text-white d-flex justify-content-center text-center'>
                  { projectDetail.content1 }
                </p>
                <p className='mt-3'>
                  { projectDetail.content2 }
                </p>
              </div>
            </div>
          </div>

          <div className="row">
          <div className="col-lg-12">
              <div className="project-details-content-2 pt-5 pb-5">
                <div className="project-thumb">
                  <img src={process.env.PUBLIC_URL + `/img/project/project-15-1.png`} alt="images" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Project2